/* eslint angular/window-service: 0 */
/** Cannot use angular's $window in Configuration, because it gets
 * intialised BEFORE the Service gets initialised.' */

(function() {
    'use strict';

    angular.module( APP_ID )
        .config([ '$compileProvider', '$httpProvider', '$logProvider', '$anchorScrollProvider', '$analyticsProvider', 'AppProvider', '$qProvider', AppBootstrapper ]);

    /**
     * Pre-configures (a.k.a 'bootstraps') application before it is run.
     *
     * @param {ng.ICompileProvider} $compileProvider
     * @param {ng.IHttpProvider} $httpProvider
     * @param {ng.ILogProvider} $logProvider
     * @param {ng.IAnchorScrollProvider} $anchorScrollProvider
     * @param {AppProvider} AppProvider
     * @param {$analyticsProvider} $analyticsProvider
     * @param {ng.qProvider} ng.qProvider
     */
    function AppBootstrapper(
        $compileProvider,
        $httpProvider,
        $logProvider,
        $anchorScrollProvider,
        $analyticsProvider,
        AppProvider,
        $qProvider
    ){

        /* ===== APP'S CONFIGURATION ======================================== */


        var isDevelopmentMode = false;

        /** @type {string} */
        var subdomain         = window.location.host.split( '.' )[ 0 ];





        /* ===== ON INITIALISATION ========================================== */


        /** @constructor */
        (function init(){
            /** For testing/development purposes *ONLY* - comment out! */
            isDevelopmentMode = AppProvider.isDevelopmentMode(),

            configureLogging();

            // Enable http caching
            $httpProvider.defaults.cache = true;

            // Analytics Setup
            $analyticsProvider.withBase( true );  /* Records full path */

            autosetContentMode();

            $anchorScrollProvider.disableAutoScrolling();
        })();





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function autosetContentMode() {
            /* Set application modes */
            AppProvider.setContentModeFromSubdomain( subdomain );
        }

        function configureLogging() {
            // Turns on/off additional debugging info for Angular if in development mode.
            $compileProvider.debugInfoEnabled( isDevelopmentMode );

            // https://docs.angularjs.org/api/ng/service/$log
            $logProvider.debugEnabled( isDevelopmentMode );

            // silences 'possibly unhandled rejection' console messages in FF
            // see http://stackoverflow.com/questions/41063947/angular-1-6-0-possibly-unhandled-rejection-error
            $qProvider.errorOnUnhandledRejections( false );
        }
    };
})();


/** Manually binds the app to the DOM. */
angular.element( document ).ready( function() {

    angular.bootstrap( document, [ APP_ID ], {
        // Strict dependency injection (improves speed + checks minification readiness)
        strictDi: true
    });
});
